import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=5137bb9f&"
import script from "./Simulator.vue?vue&type=script&lang=ts&"
export * from "./Simulator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports